import { Stack } from '@mui/material';
import type { AxiosError } from 'axios';
import { useNavigate } from 'react-router';
import { useNotification } from '@/context/notification';
import { useDeleteAcademicSituation } from '@/data/learning/academic-situation';
import { AcademicSituationCard } from '@/packages/academic-hub/components/academic-situation-card';
import { EmptyHubState } from '@/packages/academic-hub/components/empty-hub-state';
import type { AcademicSituation } from '@/models/learning/academic-situation';

interface SituationListProps {
  situations: AcademicSituation[];
  onSearchCourses: () => void;
  onAddExternalCourse: () => void;
}

export const SituationList = ({
  situations,
  onSearchCourses,
  onAddExternalCourse,
}: SituationListProps) => {
  const { toast } = useNotification();
  const navigate = useNavigate();
  const { mutate: deleteSituation } = useDeleteAcademicSituation();

  const handleDelete = (situationId: string) => {
    deleteSituation(situationId, {
      onSuccess: () => {
        toast({
          title: 'Curso removido',
          content: 'O curso foi removido do seu hub acadêmico.',
          type: 'success',
        });
      },
      onError: (error) => {
        toast({
          title: 'Erro',
          content:
            (error as AxiosError<{ errors?: string[] }>).response?.data
              ?.errors?.[0] || 'Não foi possível remover o curso.',
          type: 'error',
        });
      },
    });
  };

  if (situations.length === 0) {
    return (
      <EmptyHubState
        onSearchCourses={onSearchCourses}
        onAddExternalCourse={onAddExternalCourse}
      />
    );
  }

  return (
    <Stack spacing={1}>
      {situations.map((situation) => (
        <AcademicSituationCard
          key={situation.id}
          situation={situation}
          onClick={({ expandForm } = {}) =>
            navigate(
              `/hub-academico/${situation.id}${expandForm ? '?expand=status' : ''}`
            )
          }
          onDelete={() => handleDelete(situation.id)}
        />
      ))}
    </Stack>
  );
};
